import CostTypeRestModel from "../../register/costTypeRestModel";

export default interface SettlementCostDocumentItemRestModel {
    id: number,
    costType: CostTypeRestModel,
    descriptionDetailed: string,
    isDocumentCorrection: boolean,
    price: number,
    pricePln: number,
    netto: number,
    nettoPln: number,
    brutto: number,
    bruttoPln: number,
    quantity: number,
    taxRate: number,
    tax: number,
    taxPln: number,
    taxTypeId: number,
    serviceTypeId: number,
    unit: string,
    isManualEdit: boolean,
}

// Wszystkie pola muszą istnieć w obiekcie, aby były reaktywne w Vue 2.
export function createEmptyCostDocumentItem(): SettlementCostDocumentItemRestModel {
    return {
        id: undefined,
        costType: {} as CostTypeRestModel,
        descriptionDetailed: undefined,
        isDocumentCorrection: false,
        price: 0,
        pricePln: 0,
        netto: 0,
        nettoPln: 0,
        brutto: 0,
        bruttoPln: 0,
        quantity: 1,
        taxRate: 0,
        tax: 0,
        taxPln: 0,
        taxTypeId: undefined,
        serviceTypeId: undefined,
        unit: "SZT.",
        isManualEdit: false,
    } as any as SettlementCostDocumentItemRestModel;
}